import { render, staticRenderFns } from "./UpcomingRent.vue?vue&type=template&id=00b93ded&"
import script from "./UpcomingRent.vue?vue&type=script&lang=js&"
export * from "./UpcomingRent.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingRent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports